import SocialShell from '@/components/social/SocialShell';
import { sponsorTheme } from '@/components/social/themes';

export default function SponsorClub() {
  return <SocialShell clubId="sponsors-club" theme={sponsorTheme} canPost />;
}
